module.exports = __webpack_public_path__ + "static/media/214x152_9 copy.a3d62add.png";